export default "__VITE_ASSET__5QXHeywy__"